import { Component } from 'react';

import CheckBox from '../CheckBox';
import { CheckBoxProps } from '../CheckBox/CheckBox';

interface Props extends CheckBoxProps {
  onPress: Function;
  value: number | string;
  testID?: string;
}

export default class RadioButton extends Component<Props> {
  onPress = () => {
    this.props.onPress(this.props.value);
  };

  render() {
    return (
      <CheckBox
        {...this.props}
        onPress={this.onPress}
        checkBoxStyle={{ borderRadius: 100 }}
      />
    );
  }
}
